import React from 'react';

export const DownloadTemplate = ({ className }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="39.4439"
        y="39.4439"
        width="38.8878"
        height="38.8878"
        rx="19.4439"
        transform="rotate(-180 39.4439 39.4439)"
        fill="#D4002A"
      />
      <rect
        x="39.4439"
        y="39.4439"
        width="38.8878"
        height="38.8878"
        rx="19.4439"
        transform="rotate(-180 39.4439 39.4439)"
        stroke="#D4002A"
        strokeWidth="1.11223"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_2860_40851)">
        <path
          d="M19.4219 21.5742V12.8242"
          stroke="white"
          strokeWidth="1.28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.2969 21.5742V25.9492C26.2969 26.115 26.231 26.274 26.1138 26.3912C25.9966 26.5084 25.8376 26.5742 25.6719 26.5742H13.1719C13.0061 26.5742 12.8471 26.5084 12.7299 26.3912C12.6127 26.274 12.5469 26.115 12.5469 25.9492V21.5742"
          stroke="white"
          strokeWidth="1.28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5469 18.4492L19.4219 21.5742L16.2969 18.4492"
          stroke="white"
          strokeWidth="1.28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2860_40851">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(9.42188 9.69824)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
